import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'userGroups',
})
export class UserGroupsPipe implements PipeTransform {
  transform(value: Array<{ name: string }>): string {
    return value.map(item => item.name).join(',')
  }
}
